import React, { useEffect } from 'react';
import { Modal, Button, activateTheme, themes, Grid } from '../../../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import '../../../../../css/components/PopUps/PopUps.scss';
import messages from '../messages';

export function FileUploadModal({
  showModal,
  setShowModal,
  maxFilesModalErrorMessage,
  localParams,
}) {
  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);
  return showModal.isOpen ? (
    <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
      <Modal
        id="fileupload_modal"
        isOpen={showModal.isOpen}
        onRequestClose={() => {
          setShowModal((prevState) => ({
            ...prevState,
            isOpen: false,
          }));
        }}
      >
        <Grid>
          <Grid.Row mt4>
            <span className="pop-up-title"><FormattedMessage {...messages.someUploads} /></span>
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <span className="pop-up-text-bigger"><FormattedMessage id={maxFilesModalErrorMessage} defaultMessage={maxFilesModalErrorMessage} /></span>
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <span className="pop-up-text-bigger"><FormattedMessage {...messages.filesNotUploaded} /></span>
            {showModal.removedFiles && showModal.removedFiles.map((removedFile) => <span key={`removed-file-${Math.random() * 0xffffffffffff}`} className="pop-up-text-bigger{">{removedFile.name}</span>)}
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <span className="pop-up-text-bigger"><FormattedMessage {...messages.dontWorry} /></span>
          </Grid.Row>
          <Grid.Row>
            <span className="center">
              <Button
                className="black-button"
                onClick={() => {
                  setShowModal((prevState) => ({
                    ...prevState,
                    isOpen: false,
                  }));
                }}
              ><FormattedMessage {...messages.okay} />
              </Button>
            </span>
          </Grid.Row>
        </Grid>
      </Modal>
    </IntlProvider>
  ) : null;
}
